import Cookies from 'js-cookie';

import { IS_AUTHORIZED_COOKIE_NAME } from '../constants/auth';

export const selectIsAuthorized = () => Cookies.get(IS_AUTHORIZED_COOKIE_NAME) === '1';

